import { Component, OnInit, Input } from '@angular/core';
import { AppDataService, ConfigService, MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';
import { AppComponent } from 'app/app.component';

export enum MerchantImageTypeEnum {
    StoreImage = 1,
    CoverImage = 2
};

@Component({
    selector: 'partner-appconfig-store-branding',
    templateUrl: './partner-appconfig-store-branding.component.html',
    styleUrls: ['./partner-appconfig-store-branding.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class PartnerAppConfigStoreBrandingComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    constructor(private appData: AppDataService, public configService: ConfigService,
        private merchantService: MerchantService,
        public messageService: MessageService, public app: AppComponent) {
        this.handleHideUpdateStore = this.handleHideUpdateStore.bind(this);
        this.handleHideImagesLibrary = this.handleHideImagesLibrary.bind(this);
    }
    ngOnInit(): void {
        this.detailMerchant();
    }
    public merchantData: any = {};
    public loading: boolean = false;

    public showUpdateStoreSidebar: boolean = false;
    public showImagesLibrary: boolean = false;

    public merchantImageTypeEnum = MerchantImageTypeEnum;
    public selectedImageType: any;
    public showRemoveImageDialog: boolean = false;

    public handleHideUpdateStore() {
        this.showUpdateStoreSidebar = false;
    }
    public handleShowUpdateStore() {
        this.showUpdateStoreSidebar = true;
    }
    public handleHideImagesLibrary() {
        this.showImagesLibrary = false;
    }
    public handleShowImagesLibrary() {
        this.showImagesLibrary = true;
    }

    public detailMerchant() {
        this.loading = true;

        const dto = { MerchantId: this.appData.authData.MerchantId };

        this.merchantService.detailMerchant(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.merchantData = data;
        });
    }

    public handleShowRemoveImageDialog(imageType: MerchantImageTypeEnum) {
        this.selectedImageType = imageType;
        this.showRemoveImageDialog = true;
    }

    public removeMerchantImage() {
        const dto = {
            MerchantId: this.appData.authData.MerchantId,
            ImageType: this.selectedImageType
        };

        if (!dto.ImageType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Image type is not selected' });
            return;
        }
        this.loading = true;

        this.merchantService.removeMerchantImage(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.showRemoveImageDialog = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image has been removed' });
        }).catch(err => {
            this.loading = false;
            throw err;
        });
    }
}
